/*
  LIOR - the tabs under the product in the style of iOS 27
  (assets/lior-ios-tabs.css; loaded by sections/main-product.liquid with the
  iOS product layer, which keeps opening and closing the rows on a spring).

  The rows stay the theme's own <details>. This file only dresses them:
    - each row gets an icon tile in the colours of the iOS menu, picked from
      its heading (details = blue page, shipping = green truck, ...)
    - what is inside is read once and laid out the way iOS lays things out:
        "Label: value" lines and bold lead-ins become rows on a white inset
        group, with an icon where the words say what the row is about;
        numbered lists and "how it works" become steps;
        delivery times become cards with the number large, and the card that
        applies to this product is marked (with its arrival date);
        "important" and refund lines become tinted notes;
        WhatsApp / Instagram / phone lines become buttons.
  The words, links and order are the merchant's own: nothing is rewritten, so
  editing a block in the theme editor still changes what shows. A description
  that comes with its own design (its own <style>) is left exactly as it is.
*/
(function () {
  'use strict';

  if (window.__liorIosTabs) return;
  window.__liorIosTabs = true;

  var D = document;
  var W = window;

  /* ------------------------------------------------------------------------
     Glyphs: the 24-point grid, round caps and joins of the iOS menu
     (snippets/lior-im-icon.liquid), drawn in currentColor
     ------------------------------------------------------------------------ */
  var G = {
    doc: '<path d="M7 3.5h6.5L18 8v12.5H7z"/><path d="M13.5 3.5V8H18M9.8 12.2h5.4M9.8 15.6h5.4"/>',
    truck: '<path d="M3.5 7h10v8.5h-10z"/><path d="M13.5 10h3.6l3.4 3.4v2.1h-7"/><circle cx="7.3" cy="17" r="1.6"/><circle cx="16.8" cy="17" r="1.6"/>',
    seal: '<path d="M12 3.4 14.1 5l2.6-.2.8 2.5 2.2 1.5-.9 2.4.9 2.4-2.2 1.5-.8 2.5-2.6-.2L12 20.6 9.9 19l-2.6.2-.8-2.5-2.2-1.5.9-2.4-.9-2.4 2.2-1.5.8-2.5 2.6.2z"/><path d="m9.2 12.2 2 2 3.8-4.1"/>',
    sparkle: '<path d="M11 3.5l1.7 4.8 4.8 1.7-4.8 1.7L11 16.5l-1.7-4.8L4.5 10l4.8-1.7z"/><path d="M17.5 14.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z"/>',
    tag: '<path d="M3.6 11.9V5.1A1.5 1.5 0 0 1 5.1 3.6h6.8a1.5 1.5 0 0 1 1.1.4l7.3 7.3a1.5 1.5 0 0 1 0 2.1l-6.9 6.9a1.5 1.5 0 0 1-2.1 0L4 13a1.5 1.5 0 0 1-.4-1.1z"/><circle cx="8" cy="8" r="1.4"/>',
    question: '<circle cx="12" cy="12" r="8.6"/><path d="M9.6 9.6a2.4 2.4 0 1 1 3.4 2.2c-.6.3-1 .8-1 1.5v.5"/><path class="lit-dot" d="M12 16.8h.01"/>',
    glasses: '<path class="lit-tint" d="M3.2 9.5h7c.4 0 .7.3.7.7v.9c0 2.9-1.8 4.9-4.3 4.9-2.2 0-3.8-1.7-4-4.2L2.5 10.3c0-.4.3-.8.7-.8zM20.8 9.5h-7c-.4 0-.7.3-.7.7v.9c0 2.9 1.8 4.9 4.3 4.9 2.2 0 3.8-1.7 4-4.2l.1-1.4c0-.4-.3-.8-.7-.8z"/><path d="M1.6 9.5h20.8M10.9 11c.7-.5 1.5-.5 2.2 0"/>',
    returns: '<path d="M9 7.5 5.5 11 9 14.5"/><path d="M5.5 11h9a4 4 0 0 1 0 8H12"/>',
    ruler: '<path d="M4.3 15.4 15.4 4.3a1.4 1.4 0 0 1 2 0l2.3 2.3a1.4 1.4 0 0 1 0 2L8.6 19.7a1.4 1.4 0 0 1-2 0l-2.3-2.3a1.4 1.4 0 0 1 0-2z"/><path d="m7.4 12.3 1.6 1.6M9.9 9.8l1.1 1.1M12.4 7.3l1.6 1.6"/>',
    info: '<circle cx="12" cy="12" r="8.6"/><path d="M12 11v5.4"/><path class="lit-dot" d="M12 7.8h.01"/>',
    shield: '<path d="M12 3.2 5.3 5.7v5.6c0 4.3 2.8 7.8 6.7 9.4 3.9-1.6 6.7-5.1 6.7-9.4V5.7z"/><path d="m9 12.1 2.1 2.1 4-4.3"/>',
    layers: '<path d="M12 4.2 20.4 8.5 12 12.8 3.6 8.5z"/><path d="m3.6 12.3 8.4 4.3 8.4-4.3M3.6 16 12 20.3l8.4-4.3"/>',
    gem: '<path d="M7.3 4.5h9.4l3.8 4.9L12 19.8 3.5 9.4z"/><path d="M3.5 9.4h17M9.6 4.5 8.3 9.4 12 19.8l3.7-10.4-1.3-4.9"/>',
    factory: '<path d="M3.6 20.3v-9.2l5 3.1v-3.1l5 3.1V7.6h3V4h2.6v16.3z"/><path d="M2.6 20.3h18.8M7.2 17.1h1.4M11.2 17.1h1.4"/>',
    camera: '<path d="M4.6 7.6h2.8l1.5-2.2h6.2l1.5 2.2h2.8c.9 0 1.6.7 1.6 1.6v8.6c0 .9-.7 1.6-1.6 1.6H4.6c-.9 0-1.6-.7-1.6-1.6V9.2c0-.9.7-1.6 1.6-1.6z"/><circle cx="12" cy="13.2" r="3.4"/>',
    star: '<path d="m12 3.8 2.5 5.1 5.6.8-4 3.9.9 5.6-5-2.6-5 2.6.9-5.6-4-3.9 5.6-.8z"/>',
    chat: '<path d="M4.5 6.5A2.5 2.5 0 0 1 7 4h10a2.5 2.5 0 0 1 2.5 2.5v7A2.5 2.5 0 0 1 17 16h-6.2l-4.3 3.6V16H7a2.5 2.5 0 0 1-2.5-2.5z"/>',
    sliders: '<path d="M4 7.6h8.8M17.6 7.6H20M4 16.4h2.4M11.2 16.4H20"/><circle cx="15.2" cy="7.6" r="2.4"/><circle cx="8.8" cy="16.4" r="2.4"/>',
    display: '<rect x="3.4" y="4.4" width="17.2" height="11.6" rx="2.2"/><path d="M9.2 20h5.6M12 16v4"/>',
    eye: '<path d="M2.6 12S6 5.8 12 5.8 21.4 12 21.4 12 18 18.2 12 18.2 2.6 12 2.6 12z"/><circle cx="12" cy="12" r="3"/>',
    sun: '<circle cx="12" cy="12" r="3.8"/><path d="M12 2.8v2M12 19.2v2M2.8 12h2M19.2 12h2M5.5 5.5l1.4 1.4M17.1 17.1l1.4 1.4M5.5 18.5l1.4-1.4M17.1 6.9l1.4-1.4"/>',
    card: '<rect x="3" y="5.6" width="18" height="12.8" rx="2.4"/><path d="M3 9.8h18M6.6 14.6h3.8"/>',
    box: '<path d="M12 3.3 19.8 7.3v9.4L12 20.7l-7.8-4V7.3z"/><path d="M4.2 7.3 12 11.3l7.8-4M12 11.3v9.4M8.1 5.3l7.8 4"/>',
    calendar: '<rect x="4" y="5.6" width="16" height="14.6" rx="2.6"/><path d="M4 10h16M8.4 3.6v3.6M15.6 3.6v3.6"/><path class="lit-dot" d="M8.6 14h.01M12 14h.01M15.4 14h.01"/>',
    bolt: '<path d="M13.2 3 5.8 13h5.4l-.9 8 7.4-10h-5.4z"/>',
    alert: '<path d="M10.3 4.7 3.3 17.1a2 2 0 0 0 1.7 3h14a2 2 0 0 0 1.7-3L13.7 4.7a2 2 0 0 0-3.4 0z"/><path d="M12 9.6v4.2"/><path class="lit-dot" d="M12 16.8h.01"/>',
    check: '<path d="m5.5 12.5 4.2 4.2 8.8-9.4"/>',
    checkc: '<circle class="lit-fill" cx="12" cy="12" r="9.2"/><path class="lit-on" d="m8.2 12.3 2.6 2.6 5-5.4"/>',
    wa: '<path class="lit-fill" fill-rule="evenodd" d="M12 2.6a9.4 9.4 0 0 0-8.1 14.2L2.6 21.4l4.7-1.2A9.4 9.4 0 1 0 12 2.6zm5.4 13.2c-.2.6-1.3 1.2-1.8 1.3-.5 0-.9.2-3.1-.6-2.6-1-4.3-3.7-4.4-3.9-.1-.2-1-1.4-1-2.7s.7-1.9.9-2.2c.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 1.9c.1.2.1.3 0 .5l-.4.6-.4.4c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.1 1 2.1 1.3 2.4 1.4.3.2.5.1.6-.1l.9-1.1c.2-.3.4-.2.7-.1l1.8.9c.3.1.5.2.5.3.1.2.1.7-.1 1.3z"/>',
    ig: '<rect x="3.6" y="3.6" width="16.8" height="16.8" rx="5"/><circle cx="12" cy="12" r="3.9"/><path class="lit-dot" d="M17.1 6.9h.01"/>',
    phone: '<path d="M7.4 3.8h2.2l1.3 4-1.8 1.3a10.6 10.6 0 0 0 5.8 5.8l1.3-1.8 4 1.3v2.2a2 2 0 0 1-2.1 2A15.6 15.6 0 0 1 5.4 5.9a2 2 0 0 1 2-2.1z"/>'
  };

  function ic(name, cls) {
    return '<svg class="lit-ic' + (cls ? ' ' + cls : '') + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (G[name] || G.check) + '</svg>';
  }
  function tile(name, colour, cls) {
    return '<span class="lit-tile' + (cls ? ' ' + cls : '') + '" data-lit-c="' + colour + '" aria-hidden="true">' + ic(name) + '</span>';
  }

  /* What a row is about, from its heading (first match wins) */
  var KINDS = [
    { k: 'desc', re: /תיאור|description/i, g: 'doc', c: 'blue' },
    { k: 'ship', re: /משלוח|אספקה|shipping|delivery/i, g: 'truck', c: 'green' },
    { k: 'quality', re: /דיוק|איכות|quality/i, g: 'seal', c: 'orange' },
    { k: 'custom', re: /הזמנה אישית|בהזמנה|custom/i, g: 'sparkle', c: 'purple' },
    { k: 'plans', re: /מסלול|כלול|מחיר/, g: 'tag', c: 'orange' },
    { k: 'how', re: /איך זה עובד|איך מזמינים|שלבים/, g: 'question', c: 'indigo' },
    { k: 'lenses', re: /עדש/, g: 'glasses', c: 'teal' },
    { k: 'returns', re: /החזר|החלפ|return/i, g: 'returns', c: 'red' },
    { k: 'size', re: /מידה|מידות|size/i, g: 'ruler', c: 'purple' },
    { k: 'care', re: /טיפול|ניקוי|care/i, g: 'sparkle', c: 'mint' }
  ];
  var KIND_OTHER = { k: 'other', g: 'info', c: 'gray' };

  /* What a line inside is about (its title first, then its opening words) */
  var ROWS = [
    [/החזר כספי|החזר כפסי|כסף בחזרה|אחריות|זהה למקור 100/, 'shield', 'green'],
    [/עיצוב|צורה|מידות|גזרה/, 'ruler', 'blue'],
    [/חומר/, 'layers', 'orange'],
    [/גימור|לוגו|חריט|תפר/, 'gem', 'purple'],
    [/מייצר|מפעל|ייצור|מיוצר/, 'factory', 'orange'],
    [/רפליק|מדויק|דיוק|מקפיד/, 'seal', 'blue'],
    [/תמונה|אינסטגרם|ראיתם|צילום/, 'camera', 'pink'],
    [/איכות/, 'star', 'yellow'],
    [/שירות|זמינים|לקוח|ייעוץ/, 'chat', 'cyan'],
    [/התאמה|בהתאמה|טעמ|מותאם/, 'sliders', 'indigo'],
    [/אור כחול|מסכים|מסך/, 'display', 'blue'],
    [/רפלקס|השתקפ|סנוור/, 'eye', 'teal'],
    [/מתכה|בשמש|UV/i, 'sun', 'orange'],
    [/עדש|מסגרת|מרשם|משקפ/, 'glasses', 'indigo'],
    [/בסל משולב|בנפרד|קופסה|אריזה/, 'box', 'brown'],
    [/משלוח|עד הבית|עד דלת|נשלח|אספקה/, 'truck', 'green'],
    [/תשלום|אשראי|כרטיס/, 'card', 'blue'],
    [/מחיר|הצעת|₪/, 'tag', 'orange'],
    [/ימי עסקים|שישי|שבת|חגים/, 'calendar', 'red'],
    [/החלפ|החזר/, 'returns', 'red'],
    [/וואטסאפ|whatsapp/i, 'wa', 'wa'],
    [/טלפון|התקשר/, 'phone', 'blue']
  ];

  var GUARANTEE = /החזר כספי|החזר כפסי|כסף בחזרה|זהה למקור 100/;
  var WARN = /^(חשוב|שימו לב|הערה|לתשומת לב|אזהרה|שים לב)/;
  var PRICE = /₪\s?[\d.,]+|[\d.,]+\s?₪/;
  var DAYS = /(\d+(?:\s*[–—-]\s*\d+)?)\s*ימי\s+עסקים/;

  /* ------------------------------------------------------------------------
     Small helpers
     ------------------------------------------------------------------------ */
  function clean(s) { return String(s || '').replace(/[\s ​‎‏]+/g, ' ').trim(); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function make(tag, cls, html) {
    var e = D.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function put(parent, nodes) {
    for (var i = 0; i < (nodes || []).length; i++) parent.appendChild(nodes[i]);
    return parent;
  }
  function kids(el) { return Array.prototype.slice.call(el.childNodes); }
  function textOf(nodes) {
    var s = '';
    for (var i = 0; i < (nodes || []).length; i++) s += nodes[i].textContent;
    return clean(s);
  }
  var MEDIA = 'img,picture,iframe,video,svg,table';
  function hasMedia(nodes) {
    for (var i = 0; i < (nodes || []).length; i++) {
      var n = nodes[i];
      if (n.nodeType === 1 && (n.matches(MEDIA) || n.querySelector(MEDIA))) return true;
    }
    return false;
  }
  function isBlank(el) { return !clean(el.textContent) && !el.querySelector(MEDIA); }
  function firstReal(el) {
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3 && !clean(n.nodeValue)) continue;
      if (n.nodeType === 8) continue;
      if (n.nodeType === 1 && n.tagName === 'BR') continue;
      return n;
    }
    return null;
  }
  function firstText(n) {
    if (n.nodeType === 3) return n;
    var tw = D.createTreeWalker(n, 4, null);
    var t;
    while ((t = tw.nextNode())) if (t.nodeValue.length) return t;
    return null;
  }
  /* Leading <br>s, blanks and the ":" / "–" that join a label to its words */
  function trimLead(nodes) {
    nodes = nodes.slice();
    for (var guard = 0; nodes.length && guard < 50; guard++) {
      var n = nodes[0];
      if (n.nodeType === 8 || (n.nodeType === 1 && n.tagName === 'BR')) { nodes.shift(); continue; }
      var t = firstText(n);
      if (!t) {
        if (n.nodeType === 1 && hasMedia([n])) break;
        nodes.shift();
        continue;
      }
      var v = t.nodeValue.replace(/^[\s ‎‏:：\-–—]+/, '');
      if (v !== t.nodeValue) t.nodeValue = v;
      if (!clean(n.textContent) && !hasMedia([n])) { nodes.shift(); continue; }
      break;
    }
    return nodes;
  }
  function noStyle(root) {
    if (root.nodeType !== 1) return root;
    var all = [root].concat(qa(root, '*'));
    for (var i = 0; i < all.length; i++) {
      var e = all[i];
      if (/^(IMG|IFRAME|VIDEO|SVG|PATH)$/i.test(e.tagName)) continue;
      e.removeAttribute('style');
      e.removeAttribute('data-start');
      e.removeAttribute('data-end');
    }
    return root;
  }
  function iconFor(title, text) {
    var t = clean(title);
    var i;
    if (t) for (i = 0; i < ROWS.length; i++) if (ROWS[i][0].test(t)) return ROWS[i];
    var s = clean(text).slice(0, 44);
    for (i = 0; i < ROWS.length; i++) if (ROWS[i][0].test(s)) return ROWS[i];
    return null;
  }
  function kindOf(title) {
    for (var i = 0; i < KINDS.length; i++) if (KINDS[i].re.test(title)) return KINDS[i];
    return KIND_OTHER;
  }

  /* ------------------------------------------------------------------------
     Reading what the merchant wrote
     ------------------------------------------------------------------------ */
  /* A description that brings its own design keeps it */
  function ownDesign(body) {
    if (body.querySelector('style, script, section, details, form, dl, template, input, button')) return true;
    for (var n = body.firstElementChild; n; n = n.nextElementSibling) {
      if (/^(DIV|ARTICLE|ASIDE)$/.test(n.tagName) && clean(n.className) && !n.classList.contains('table--responsive')) return true;
    }
    return false;
  }

  /* "<strong>Label:</strong> words" */
  function leadOf(el) {
    var f = firstReal(el);
    if (!f || f.nodeType !== 1) return null;
    var strong = null;
    if (/^(STRONG|B)$/.test(f.tagName)) strong = f;
    else if (/^(SPAN|U|EM|I)$/.test(f.tagName)) {
      var inner = firstReal(f);
      if (inner && inner.nodeType === 1 && /^(STRONG|B)$/.test(inner.tagName) && clean(inner.textContent) === clean(f.textContent)) strong = f;
    }
    if (!strong) return null;
    var title = clean(strong.textContent);
    if (!title || title.length > 90) return null;
    var rest = [];
    for (var n = strong.nextSibling; n; n = n.nextSibling) rest.push(n);
    var raw = rest.map(function (r) { return r.textContent; }).join('');
    var colon = /[:：]$/.test(title) || /^[\s ‎‏]*[:：]/.test(raw);
    title = title.replace(/[\s:：]+$/, '');
    rest = trimLead(rest);
    if (!textOf(rest) && !hasMedia(rest)) return { title: title, colon: colon, rest: null };
    return { title: title, colon: colon, rest: rest };
  }

  /* "Label: words" written without bold. A sentence that only happens to have
     a colon in it ("עיצוב עכשווי עם נגיעה על-זמנית: מוקסין...") stays a sentence */
  function pairOf(el, mode) {
    var full = clean(el.textContent);
    var m = /^([^:：]{1,34})[:：]\s*(\S[\s\S]*)$/.exec(full);
    if (!m) return null;
    var label = clean(m[1]);
    if (!label || /[.!?]/.test(label) || /^\d+$/.test(label) || /^https?$/i.test(label)) return null;
    var words = label.split(' ').length;
    if (mode === 'spec' ? words > 3 || label.length > 22 : words > 6) return null;
    if (clean(m[2]).length > 110) return null;
    var tw = D.createTreeWalker(el, 4, null);
    var node = null;
    var at = -1;
    while ((node = tw.nextNode())) {
      at = node.nodeValue.search(/[:：]/);
      if (at !== -1) break;
    }
    if (!node || at === -1) return null;
    for (var p = node.parentNode; p && p !== el; p = p.parentNode) if (p.tagName === 'A') return null;
    var links = el.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      if (links[i].compareDocumentPosition(node) & 4) return null; /* a link before the colon */
    }
    if (/\d$/.test(node.nodeValue.slice(0, at)) && /^\d/.test(node.nodeValue.slice(at + 1))) return null; /* 10:00 */
    var tail = node.splitText(at);
    tail.nodeValue = tail.nodeValue.slice(1);
    var r = D.createRange();
    r.setStartBefore(tail);
    r.setEnd(el, el.childNodes.length);
    var rest = trimLead(kids(r.extractContents()));
    if (!textOf(rest) && !hasMedia(rest)) return null;
    return { title: label, colon: true, rest: rest };
  }

  /* WhatsApp / Instagram / phone lines */
  function waHref(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.length < 8) return '';
    if (d.indexOf('972') === 0) return 'https://wa.me/' + d;
    if (d.charAt(0) === '0') return 'https://wa.me/972' + d.slice(1);
    return 'https://wa.me/' + d;
  }
  function contactOf(el) {
    var text = clean(el.textContent);
    var t = text.replace(/^[^0-9A-Za-z֐-׿@]+/, '');
    if (!t || t.length > 60) return null;
    var a = el.querySelector('a[href]');
    var href = a ? a.getAttribute('href') || '' : '';
    var value = clean(t.replace(/^[^:：]{1,16}[:：]/, ''));
    if (/wa\.me|whatsapp\.com/i.test(href) || /^(וואטסאפ|ווטסאפ|ווצאפ|whatsapp)/i.test(t)) {
      var link = /wa\.me|whatsapp\.com/i.test(href) ? href : waHref(href || value);
      if (!link) return null;
      if (/whatsapp/i.test(value) || !/\d{6}/.test(value.replace(/\D/g, ''))) value = '';
      return { t: 'contact', kind: 'wa', g: 'wa', href: link, label: 'וואטסאפ', value: value, cta: 'שאלה? כתבו לנו בוואטסאפ' };
    }
    if (/instagram\.com/i.test(href) || /^(אינסטגרם|instagram)/i.test(t)) {
      var handle = value.replace(/^@/, '').replace(/\s.*$/, '');
      var igLink = /instagram\.com/i.test(href) ? href : (handle ? 'https://www.instagram.com/' + encodeURIComponent(handle) : '');
      if (!igLink) return null;
      return { t: 'contact', kind: 'ig', g: 'ig', href: igLink, label: 'אינסטגרם', value: handle ? '@' + handle : '', cta: 'עקבו אחרינו באינסטגרם' };
    }
    if (/^tel:/i.test(href) && /^(טלפון|טל|נייד|phone)/i.test(t)) {
      return { t: 'contact', kind: 'tel', g: 'phone', href: href, label: 'טלפון', value: value, cta: 'התקשרו אלינו' };
    }
    return null;
  }

  /* <br>-separated lines, when some of them are contact lines */
  function lines(p) {
    var out = [];
    var cur = [];
    kids(p).forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === 'BR') { out.push(cur); cur = []; }
      else cur.push(n);
    });
    out.push(cur);
    return out.filter(function (ln) { return textOf(ln) || hasMedia(ln); }).map(function (ln) {
      return put(D.createElement('p'), ln);
    });
  }

  function readLine(p, out, mode) {
    if (isBlank(p)) return;
    var c = contactOf(p);
    if (c) { out.push(c); return; }
    var text = clean(p.textContent);
    var lead = leadOf(p);
    if (lead && !lead.rest) {
      if (GUARANTEE.test(lead.title)) out.push({ t: 'callout', tone: 'ok', title: '', nodes: [D.createTextNode(lead.title)] });
      else if (lead.title.length <= 70) out.push({ t: 'head', text: lead.title });
      else out.push({ t: 'prose', el: p });
      return;
    }
    if (lead) {
      if (WARN.test(lead.title)) { out.push({ t: 'callout', tone: 'warn', title: lead.title, nodes: lead.rest }); return; }
      out.push({ t: 'pair', title: lead.title, colon: lead.colon, nodes: lead.rest });
      return;
    }
    if (/[:：]$/.test(text) && text.length <= 40 && !p.querySelector('a')) {
      out.push({ t: 'head', text: text.replace(/[\s:：]+$/, '') });
      return;
    }
    var kv = pairOf(p, mode);
    if (kv) {
      if (WARN.test(kv.title)) out.push({ t: 'callout', tone: 'warn', title: kv.title, nodes: kv.rest });
      else out.push({ t: 'pair', title: kv.title, colon: true, nodes: kv.rest });
      return;
    }
    out.push({ t: 'prose', el: p });
  }

  function readList(list, mode) {
    var items = [];
    Array.prototype.forEach.call(list.children, function (li) {
      if (li.tagName !== 'LI') return;
      var host = li;
      var reals = Array.prototype.filter.call(li.childNodes, function (n) {
        return !(n.nodeType === 3 && !clean(n.nodeValue)) && n.nodeType !== 8;
      });
      if (reals.length === 1 && reals[0].nodeType === 1 && reals[0].tagName === 'P') host = reals[0];
      if (isBlank(host)) return;
      var lead = leadOf(host);
      if (lead && !lead.rest) { items.push({ title: lead.title, colon: lead.colon, nodes: null, full: true }); return; }
      if (lead) { items.push({ title: lead.title, colon: lead.colon, nodes: lead.rest }); return; }
      var kv = pairOf(host, mode);
      if (kv) { items.push({ title: kv.title, colon: true, nodes: kv.rest }); return; }
      items.push({ title: '', colon: false, nodes: trimLead(kids(host)) });
    });
    return { t: 'list', ordered: list.tagName === 'OL', items: items };
  }

  function read(body, mode) {
    var host = body;
    /* a lone wrapper <div> around everything */
    for (var guard = 0; guard < 4; guard++) {
      var only = host.children.length === 1 ? host.firstElementChild : null;
      if (!only || only.tagName !== 'DIV' || clean(only.className)) break;
      var outside = clean(host.textContent.replace(only.textContent, ''));
      if (outside) break;
      host = only;
    }
    var out = [];
    kids(host).forEach(function (n) {
      if (n.nodeType === 3) {
        if (clean(n.nodeValue)) out.push({ t: 'prose', el: put(D.createElement('p'), [n]) });
        return;
      }
      if (n.nodeType !== 1) return;
      var tag = n.tagName;
      if (/^(BR|HR|META|LINK|STYLE|SCRIPT)$/.test(tag)) return;
      if (/^H[1-6]$/.test(tag)) {
        var h = clean(n.textContent).replace(/[\s:：]+$/, '');
        if (h) out.push({ t: 'head', text: h });
        return;
      }
      if (tag === 'UL' || tag === 'OL') { out.push(readList(n, mode)); return; }
      if (tag === 'TABLE' || (tag === 'DIV' && n.classList.contains('table--responsive'))) { out.push({ t: 'raw', el: n, cls: 'lit-table' }); return; }
      if (/^(IMG|PICTURE|FIGURE|IFRAME|VIDEO)$/.test(tag)) { out.push({ t: 'raw', el: n, cls: 'lit-media' }); return; }
      if (tag === 'BLOCKQUOTE') { out.push({ t: 'callout', tone: 'info', title: '', nodes: kids(n) }); return; }
      if (/^(P|DIV|SPAN|STRONG|B|EM)$/.test(tag)) {
        if (isBlank(n)) return;
        if (tag === 'STRONG' || tag === 'B' || tag === 'EM' || tag === 'SPAN') n = put(D.createElement('p'), [n]);
        if (n.querySelector('br')) {
          var ls = lines(n.cloneNode(true));
          if (ls.length > 1 && ls.some(function (ln) { return contactOf(ln); })) {
            ls.forEach(function (ln) { readLine(ln, out, mode); });
            return;
          }
        }
        readLine(n, out, mode);
        return;
      }
      out.push({ t: 'prose', el: n });
    });
    /* in a description, a short opening line is its title */
    if (mode === 'spec' && out.length && out[0].t === 'prose') {
      var t0 = clean(out[0].el.textContent);
      if (t0 && t0.length <= 60 && !/[.!?:]$/.test(t0) && !out[0].el.querySelector('a')) out[0] = { t: 'head', text: t0, lead: true };
    }
    return out;
  }

  /* ------------------------------------------------------------------------
     Laying it out
     ------------------------------------------------------------------------ */
  function head(text, lead) {
    var p = make('p', 'lit-h' + (lead ? ' lit-h--lead' : ''));
    p.setAttribute('role', 'heading');
    p.setAttribute('aria-level', '4');
    p.textContent = text;
    return p;
  }

  function prose(els) {
    var d = make('div', 'lit-prose');
    els.forEach(function (p) { d.appendChild(noStyle(p)); });
    return d;
  }

  function callout(tone, title, nodes) {
    var d = make('div', 'lit-callout lit-callout--' + tone);
    d.innerHTML = ic(tone === 'ok' ? 'shield' : tone === 'warn' ? 'alert' : 'info', 'lit-callout__ic');
    var tx = make('div', 'lit-callout__tx');
    if (title) tx.appendChild(make('span', 'lit-callout__title', esc(title)));
    if (nodes && nodes.length) put(tx.appendChild(make('span', 'lit-callout__text')), nodes.map(noStyle));
    d.appendChild(tx);
    return d;
  }

  function steps(list) {
    var ol = make('ol', 'lit-steps');
    ol.setAttribute('role', 'list');
    list.forEach(function (s, i) {
      var li = make('li', 'lit-step');
      li.appendChild(make('span', 'lit-step__n', String(i + 1)));
      var b = make('div', 'lit-step__body');
      if (s.title) b.appendChild(make('span', 'lit-step__title', esc(s.title)));
      if (s.nodes && textOf(s.nodes)) put(b.appendChild(make('span', s.title ? 'lit-step__text' : 'lit-step__text lit-step__text--solo')), s.nodes.map(noStyle));
      li.appendChild(b);
      ol.appendChild(li);
    });
    return ol;
  }

  /* One row of an inset group */
  function row(o) {
    var li = make('li', 'lit-row lit-row--' + o.kind);
    if (o.kind === 'feature' || o.kind === 'plain') li.insertAdjacentHTML('beforeend', tile(o.g, o.c));
    else if (o.kind === 'check') li.insertAdjacentHTML('beforeend', ic('checkc', 'lit-row__check'));
    else if (o.kind === 'note') {
      li.insertAdjacentHTML('beforeend', ic(o.g, 'lit-row__glyph'));
      li.setAttribute('data-lit-c', o.c);
    }
    var body = make('div', 'lit-row__body');
    var nodes = (o.nodes || []).map(noStyle);
    if (o.kind === 'spec') {
      if (o.title) body.appendChild(make('span', 'lit-row__k', esc(o.title)));
      else li.classList.add('lit-row--solo');
      put(body.appendChild(make('span', 'lit-row__v')), nodes);
    } else if (o.kind === 'check' && o.title) {
      var x = body.appendChild(make('span', 'lit-row__text'));
      x.appendChild(make('strong', null, esc(o.title)));
      if (nodes.length) { x.appendChild(D.createTextNode(' ')); put(x, nodes); }
    } else {
      if (o.title) body.appendChild(make('span', 'lit-row__title', esc(o.title)));
      if (nodes.length && textOf(nodes)) put(body.appendChild(make('span', 'lit-row__text')), nodes);
    }
    li.appendChild(body);
    if (o.price) li.appendChild(make('span', 'lit-row__price', esc(o.price)));
    return li;
  }

  function group(cls) {
    var ul = make('ul', 'lit-group' + (cls ? ' ' + cls : ''));
    ul.setAttribute('role', 'list');
    return ul;
  }

  /* Pairs and list items: rows, broken by the notes that belong between them */
  function renderItems(items, wrap, mode) {
    var cur = null;
    var specs = [];
    function flush() {
      if (cur && cur.children.length) {
        if (specs.length) {
          var long = specs.some(function (s) { return s.v > 24 || s.k > 16; });
          cur.classList.add(long ? 'lit-group--stack' : 'lit-group--inline');
        }
        wrap.appendChild(cur);
      }
      cur = null;
      specs = [];
    }
    function add(li) {
      if (!cur) cur = group('lit-group--' + mode);
      cur.appendChild(li);
    }
    /* among "label: value" lines, a line without a label is a value of its own */
    var anySpec = mode === 'spec' && items.some(function (it) { return it.title && it.colon && textOf(it.nodes || []); });
    items.forEach(function (it) {
      var words = textOf(it.nodes || []);
      if (it.title && WARN.test(it.title)) { flush(); wrap.appendChild(callout('warn', it.title, it.nodes || [])); return; }
      if (it.full && GUARANTEE.test(it.title)) { flush(); wrap.appendChild(callout('ok', '', [D.createTextNode(it.title)])); return; }
      if (mode === 'spec') {
        if (it.title && it.colon && words) {
          specs.push({ k: it.title.length, v: words.length });
          add(row({ kind: 'spec', title: it.title, nodes: it.nodes }));
        } else if (anySpec && !it.title) {
          specs.push({ k: 0, v: words.length });
          add(row({ kind: 'spec', title: '', nodes: it.nodes || [] }));
        } else add(row({ kind: 'check', title: it.title, nodes: it.nodes || [] }));
        return;
      }
      var pm = it.title ? PRICE.exec(it.title) : null;
      if (pm) {
        var name = clean(it.title.replace(pm[0], '').replace(/[\s:–—-]+$/, '').replace(/^[\s:–—-]+/, ''));
        add(row({ kind: 'price', title: name || it.title, nodes: it.nodes || [], price: pm[0].replace(/\s+/g, '') }));
        return;
      }
      var hit = iconFor(it.title, words) || [null, 'check', 'blue'];
      add(row({ kind: it.title ? 'feature' : 'plain', g: hit[1], c: hit[2], title: it.title, nodes: it.nodes || [] }));
    });
    flush();
  }

  function cta(c) {
    var a = make('a', 'lit-cta lit-cta--' + c.kind);
    a.href = c.href;
    if (/^https?:/i.test(c.href)) { a.target = '_blank'; a.rel = 'noopener'; }
    a.innerHTML = ic(c.g) + '<span>' + esc(c.cta) + '</span>';
    return a;
  }

  function acts(list) {
    var d = make('div', 'lit-acts');
    list.forEach(function (c) {
      var a = make('a', 'lit-act lit-act--' + c.kind);
      a.href = c.href;
      if (/^https?:/i.test(c.href)) { a.target = '_blank'; a.rel = 'noopener'; }
      a.setAttribute('aria-label', c.label + (c.value ? ' ' + c.value : ''));
      a.innerHTML = '<span class="lit-act__ic">' + ic(c.g) + '</span><span class="lit-act__t">' + esc(c.label) + '</span>' +
        (c.value ? '<span class="lit-act__v" dir="ltr">' + esc(c.value) + '</span>' : '');
      d.appendChild(a);
    });
    return d;
  }

  function isConnector(b) { return b && b.t === 'prose' && clean(b.el.textContent).length <= 4; }

  function renderBlocks(blocks, wrap, mode, kind) {
    var i = 0;
    var n = blocks.length;
    while (i < n) {
      var b = blocks[i];
      if (b.t === 'pair') {
        var pairs = [];
        while (i < n && blocks[i].t === 'pair') pairs.push(blocks[i++]);
        renderItems(pairs, wrap, mode);
        continue;
      }
      if (b.t === 'list') {
        if (b.ordered) wrap.appendChild(steps(b.items));
        else renderItems(b.items, wrap, mode);
        i++;
        continue;
      }
      if (b.t === 'contact') {
        var cs = [];
        while (i < n) {
          if (blocks[i].t === 'contact') { cs.push(blocks[i++]); continue; }
          if (isConnector(blocks[i]) && blocks[i + 1] && blocks[i + 1].t === 'contact') { i++; continue; }
          break;
        }
        wrap.appendChild(cs.length === 1 ? cta(cs[0]) : acts(cs));
        continue;
      }
      if (b.t === 'prose') {
        var ps = [];
        while (i < n && blocks[i].t === 'prose') ps.push(blocks[i++].el);
        if (kind.k === 'how' && ps.length > 1) wrap.appendChild(steps(ps.map(function (p) { return { title: '', nodes: kids(p) }; })));
        else wrap.appendChild(prose(ps));
        continue;
      }
      if (b.t === 'head') { wrap.appendChild(head(b.text, b.lead)); i++; continue; }
      if (b.t === 'callout') { wrap.appendChild(callout(b.tone, b.title, b.nodes)); i++; continue; }
      if (b.t === 'raw') {
        b.el.classList.add(b.cls);
        wrap.appendChild(b.el);
        i++;
        continue;
      }
      i++;
    }
  }

  /* Shipping: the delivery times as cards, the fine print as notes, then the button */
  function linkPhrase(node, phrase, url) {
    if (!url || node.querySelector && node.querySelector('a')) return;
    var tw = D.createTreeWalker(node, 4, null);
    var t;
    while ((t = tw.nextNode())) {
      var at = t.nodeValue.indexOf(phrase);
      if (at === -1) continue;
      var mid = t.splitText(at);
      mid.splitText(phrase.length);
      var a = D.createElement('a');
      a.href = url;
      a.textContent = phrase;
      mid.parentNode.replaceChild(a, mid);
      return;
    }
  }

  function renderShip(blocks, wrap, ctx, det, kind) {
    var days = [];
    var notes = [];
    var rest = [];
    var contact = null;
    blocks.forEach(function (b) {
      if (b.t === 'pair') {
        var tx = textOf(b.nodes);
        var m = DAYS.exec(tx);
        if (m) {
          days.push({
            /* "מוצרים בקטגוריות מלאי וסייל ובגדים" reads "מלאי וסייל ובגדים" on a card */
            label: b.title.replace(/^מוצרים\s+ב?קטגורי(?:ות|ית|יה)\s+/, ''),
            num: m[1].replace(/\s+/g, '').replace(/[-—]/g, '–'),
            unit: clean(tx.slice(m.index + m[1].length)).replace(/[.。]+$/, ''),
            stock: /מלאי|סייל|בגדים/.test(b.title)
          });
          return;
        }
      }
      if (b.t === 'contact' && !contact) { contact = b; return; }
      if (b.t === 'prose') { notes.push(b.el); return; }
      rest.push(b);
    });
    if (!days.length) { renderBlocks(blocks, wrap, 'feature', kind); return; }

    var pick = -1;
    days.forEach(function (d, i) {
      if (pick !== -1) return;
      if (ctx.delivery === 'stock' && d.stock) pick = i;
      if (ctx.delivery === 'order' && !d.stock) pick = i;
    });

    var grid = make('div', 'lit-days');
    grid.setAttribute('role', 'list');
    days.forEach(function (d, i) {
      var card = make('div', 'lit-day' + (i === pick ? ' is-this' : ''));
      card.setAttribute('role', 'listitem');
      card.setAttribute('data-lit-d', d.stock ? 'stock' : 'order');
      card.innerHTML =
        '<span class="lit-day__top">' + ic(d.stock ? 'bolt' : 'calendar') + '<span>' + esc(d.label) + '</span></span>' +
        '<span class="lit-day__num">' + esc(d.num) + '</span>' +
        '<span class="lit-day__unit">' + esc(d.unit) + '</span>' +
        (i === pick ? '<span class="lit-day__this">' + ic('check') + '<span>המוצר הזה</span></span><span class="lit-day__eta" hidden></span>' : '');
      grid.appendChild(card);
    });
    wrap.appendChild(grid);

    /* this product's delivery time under the row's title, readable while it is closed */
    var sum = det.querySelector(':scope > summary');
    if (pick !== -1 && sum && !sum.querySelector(':scope > .lit-sub')) {
      var d0 = days[pick];
      var sub = make('span', 'lit-sub lit-sub--' + (d0.stock ? 'stock' : 'order'),
        ic(d0.stock ? 'bolt' : 'calendar') + '<span>' + esc(d0.num + (d0.unit ? ' ' + d0.unit : '')) + '</span>');
      var titleEl = sum.querySelector(':scope > .product-accordion--heading-text');
      if (titleEl) titleEl.insertAdjacentElement('afterend', sub);
      else sum.insertBefore(sub, sum.querySelector(':scope > .lit-trail'));
      sum.classList.add('lit-has-sub');
    }

    if (notes.length) {
      var g = group('lit-group--notes');
      notes.forEach(function (p) {
        var hit = iconFor('', p.textContent) || [null, 'info', 'gray'];
        linkPhrase(p, 'מדיניות המשלוחים', ctx.ship);
        g.appendChild(row({ kind: 'note', g: hit[1], c: hit[2], nodes: kids(p) }));
      });
      wrap.appendChild(g);
    }
    if (rest.length) renderBlocks(rest, wrap, 'feature', kind);
    if (contact) wrap.appendChild(cta(contact));
  }

  /* ------------------------------------------------------------------------
     Dress one row
     ------------------------------------------------------------------------ */
  function dress(det, ctx) {
    if (det.hasAttribute('data-lit')) return;
    det.setAttribute('data-lit', '');

    var sum = det.querySelector(':scope > summary');
    var titleEl = sum && sum.querySelector('.product-accordion--heading-text');
    var kind = kindOf(clean(titleEl ? titleEl.textContent : ''));
    det.setAttribute('data-lit-kind', kind.k);

    if (sum && !sum.querySelector(':scope > .lit-tile')) {
      sum.insertAdjacentHTML('afterbegin', tile(kind.g, kind.c, 'lit-tile--head'));
      var chev = sum.querySelector(':scope > .product-accordion--icon');
      var trail = make('span', 'lit-trail');
      if (chev) {
        sum.insertBefore(trail, chev);
        trail.appendChild(chev);
      } else sum.appendChild(trail);
    }

    var body = det.querySelector('.product-accordion--content-body');
    if (!body) return;
    if (ownDesign(body)) { body.classList.add('lit-own'); return; }

    try {
      var mode = kind.k === 'desc' ? 'spec' : 'feature';
      var src = body.cloneNode(true);
      var blocks = read(src, mode);
      if (!blocks.length) return;
      var wrap = make('div', 'lit lit--' + kind.k);
      if (kind.k === 'ship') renderShip(blocks, wrap, ctx, det, kind);
      else renderBlocks(blocks, wrap, mode, kind);
      if (!wrap.children.length) return;
      Array.prototype.forEach.call(wrap.children, function (c, i) { c.style.setProperty('--lit-i', String(Math.min(i, 8))); });
      body.textContent = '';
      body.appendChild(wrap);
      body.classList.add('lit-on');
    } catch (err) {
      /* the merchant's text stays exactly as it was */
      if (W.console && console.warn) console.warn('[lior-ios-tabs]', err);
    }
  }

  /* ------------------------------------------------------------------------
     This product: from stock or made to order, and its arrival date
     ------------------------------------------------------------------------ */
  function deliveryKind(root) {
    var a = root.getAttribute('data-lip-delivery');
    if (a === 'stock' || a === 'order') return a;
    var fd = D.getElementById('lior-floating-delivery');
    if (fd) return fd.hasAttribute('data-order-delivery') ? 'order' : 'stock';
    var d = root.querySelector('.lior-delivery');
    if (d) return d.textContent.indexOf('במלאי') === -1 ? 'order' : 'stock';
    return '';
  }
  function arrival() {
    var fd = D.getElementById('lior-floating-delivery');
    var dd = fd && fd.querySelector('[data-delivery-date]');
    return dd ? clean(dd.textContent) : '';
  }
  function paintEta(root) {
    var t = arrival();
    qa(root, '.lit-day.is-this .lit-day__eta').forEach(function (e) {
      if (e.textContent !== t) e.textContent = t;
      e.hidden = !t;
    });
  }

  /* ------------------------------------------------------------------------
     Boot, follow re-renders and the theme editor
     ------------------------------------------------------------------------ */
  var raf = 0;
  var watched = null;
  var mo = null;
  var fdMo = null;

  function scan() {
    raf = 0;
    var root = D.querySelector('.lip[data-lip]');
    if (!root) return;
    var ctx = { delivery: deliveryKind(root), ship: root.getAttribute('data-lit-ship') || '' };
    qa(root, '.product--detail-accordion').forEach(function (list) {
      list.classList.add('lit-list');
      qa(list, 'details.product-accordion--item').forEach(function (det) { dress(det, ctx); });
    });
    paintEta(root);
    if (watched !== root) watch(root);
  }
  function schedule() {
    if (!raf) raf = W.requestAnimationFrame(scan);
  }
  function watch(root) {
    watched = root;
    if (!('MutationObserver' in W)) return;
    if (mo) mo.disconnect();
    mo = new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        if (recs[i].addedNodes.length) { schedule(); return; }
      }
    });
    mo.observe(root, { childList: true, subtree: true });
    if (fdMo) fdMo.disconnect();
    var fd = D.getElementById('lior-floating-delivery');
    if (fd) {
      fdMo = new MutationObserver(function () { paintEta(root); });
      fdMo.observe(fd, { childList: true, subtree: true, characterData: true });
    }
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  W.addEventListener('load', function () {
    var root = D.querySelector('.lip[data-lip]');
    if (root) paintEta(root);
  }, { once: true });

  D.addEventListener('shopify:section:load', function () { watched = null; schedule(); });
  /* Choosing a row's block in the theme editor opens it */
  D.addEventListener('shopify:block:select', function (e) {
    var det = e.target && e.target.closest ? e.target.closest('details.product-accordion--item') : null;
    if (!det || det.open) return;
    var sum = det.querySelector(':scope > summary');
    if (sum) sum.click();
  });
})();
